import { httpsCallable, HttpsCallableResult } from 'firebase/functions';
import { useCallback, useState } from 'react';
import FirebaseFunctions from '../services/FirebaseFunctions';

const methodName = 'v1_mcp_client_expire' as const;

export type ExpireMcpClientResult = HttpsCallableResult<{ id: string; revoked: number }>;
export type ExpireMcpClientData = {
  id: string,
};

export type ExpireMcpClient = Readonly<[
  run: (data: ExpireMcpClientData) => Promise<ExpireMcpClientResult>,
  progress: boolean,
  err?: Error
]>;

export const useExpireMcpClient = (): ExpireMcpClient => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | undefined>(undefined);
  const run = useCallback(
    async (data: ExpireMcpClientData): Promise<ExpireMcpClientResult> => {
      setLoading(true);
      setError(undefined);
      try {
        const callable = httpsCallable<
          { action: typeof methodName; data: ExpireMcpClientData },
          { id: string; revoked: number }
        >(FirebaseFunctions, 'app');
        return await callable({ action: methodName, data });
      } catch (err) {
        const e = err instanceof Error ? err : new Error(String(err));
        setError(e);
        throw e;
      } finally {
        setLoading(false);
      }
    },
    []
  );
  return [run, loading, error];
};
